import { padStart } from 'lodash'

export default function formatDuration (milliseconds, visibilityOptions = { hours: 'auto', seconds: 'visible' }) {
  let seconds = Math.floor(milliseconds / 1000)

  const hours = Math.floor(seconds / 3600)

  seconds = seconds - hours * 3600
  const minutes = Math.floor(seconds / 60)

  seconds = seconds - minutes * 60

  const H = hours
  const mm = padStart(minutes, 2, '0')
  const ss = padStart(seconds, 2, '0')

  let duration = ''

  if (visibilityOptions.hours === 'visible') {
    duration = H
  } else if (visibilityOptions.hours === 'auto') {
    if (hours > 0) {
      duration = H
    }
  }

  if (duration !== '') {
    duration = duration + `:${mm}`
  } else {
    duration = mm
  }

  if (visibilityOptions.seconds === 'visible') {
    duration = duration + `:${ss}`
  }

  return duration
}



// WEBPACK FOOTER //
// ./src/lib/format-duration.js